export default __webpack_public_path__ + "static/media/2-3_image9.93b4c391.png";